import { Sound as CommonSound } from "common/sound";
// import { toPath } from "../resources";
import * as R from "ramda";
export const fileName = "사운드 소스.m4a";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "ambulanceBackground":
            return ["ambulanceBackground"];
    }
};
export function speakingName(id) {
    if (id < 1 || id > 6) {
        throw new Error(`Invalid speaking number ${id}`);
    }
    return `speaking${id}`;
}
const sprites = {
    ambulanceBackground: [0 + 0 / 30, 4 + 5 / 30],
    heartBeatMachine: [4 + 11 / 30, 4 + 25 / 30],
    heartBeat1: [5 + 7 / 30, 5 + 29 / 30],
    heartBeat2: [5 + 29 / 30, 6 + 15 / 30],
    heartBeat3: [6 + 15 / 30, 6 + 24 / 30],
    grandpaEffect: [6 + 26 / 30, 8 + 10 / 30],
    opening: [8 + 10 / 30, 12 + 4 / 30],
    openingTransition: [12 + 4 / 30, 13 + 6 / 30],
};
export const spritesDurations = R.map(([start, end]) => end * 1000 - start * 1000, sprites);
const spriteForHowler = R.map(([start, end]) => [
    0.05 + Math.floor(start * 1000),
    0.05 + Math.floor(end * 1000 - start * 1000),
], sprites);
//# sourceMappingURL=sound.js.map